import React from 'react';
import styled from 'styled-components';
import NavLink from './NavLink';
import { Flex } from '../../utils/components';
import { media } from '../../utils/theme';

const StyledCTA = styled(NavLink)`
  padding: 24px 32px;
  align-self: initial;
  font-size: 32px;
  border-radius: 8px;
  ${media.lessThan('md')`
    padding: 16px 24px;
    font-size: 24px;
  `}
`;

export default function Cta() {
  return (
    <StyledCTA to='/search' bg='red' color='white' fontSize={5}>
      Find your kitas
    </StyledCTA>
  );
}

export const CenteredCta = () => {
  return (
    <Flex justifyContent={'center'}>
      <Cta />
    </Flex>
  );
};
